<template>
    <div>
        <div class="box" :value="confirmEvent">
            <div style="display:flex">
                <div>
                    <BBtnSelectUploadImg
                        class="button"
                        btn-txt="选择上传图片"
                        :isMulti="isMulti"
                        v-model="dataImg"
                    />
                </div>
                <div class="tip">图片最大不超过5MB，最多一次可上传5张</div>
            </div>
            <div class="video-box">
                <div v-show="display" class="inner-box">
                    <div v-for="(item,index) in imgList" :key="index" class="item">
                        <img style="width:110px;height:110px;" :src="item.fileURL"/>
                        <img v-if="item.deleteFlag" class="delete-img" src="@/assets/circle-delete.png" v-on:click="deleteImg(index)" alt=""/>
                        <BProgress v-if="item.imgFlag" v-model="item.progress" style="width:110px"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import BBtnSelectUploadImg from "../../components2/BBtnSelectUploadImg";
    import {upload} from "@/api/upload"
    import BProgress from "../../components2/BProgress";
    import Vue from 'vue';

    export default {
        name: "PopupContents",
        props: {
            data: Object,
            confirmEvent: Boolean
        },
        components: {
            BBtnSelectUploadImg,
            BProgress,
        },
        data() {
            return {
                snackbar: false,
                timeout: 2000,
                snackbarColor: 'error',
                snackbarText: '',
                returnData: [],
                dataImg: null,
                display: false,
                isMulti: true,
                imgList: [],
                progress: 0,
                imgFlag: true,
                deleteFlag: true,
                global_param: '',
                imgCheckArray: [],
                itemCount: {},
                imgCount: 0,
            }
        },
        mounted() {
            if (
                this.data !== null &&
                this.data !== "" &&
                this.data !== undefined
            ) {
                console.log("this.data===",this.data)
                this.itemCount = this.data;
            }
        },
        methods: {
            work() {
                this.$emit("ok", this.returnData);
            },
            deleteImg(index){
                this.imgList.splice(index,1)
                this.imgCheckArray.splice(index,1)
            },
            async doUpload() {
                console.info(this.imgList);
                // 判断文件总数不大于5张图片
                console.log("this.itemCount",this.itemCount)
                console.log("this.imgList",this.imgList.length)
                this.imgCount = this.itemCount.imgCount + this.imgList.length
                if(this.imgCount > 5) {
                    Vue.prototype.$valertbar.show("最多上传五张图片！");
                    this.$emit("input", false);
                    return
                }

                for (var i=0; i<this.imgList.length; i++) {
                    this.global_param = i
                    var formData = new FormData();
                    formData.append('file', this.imgList[i].file);
                    const data = await upload(formData,this.doUploadProgress);
                    if (this.progress > 100 || this.progress == 100) {
                        this.imgList[i].progress = this.progress
                        this.imgList[i].deleteFlag = false
                        this.imgList[i].imgFlag = false
                        this.progress = 0
                        if (this.global_param == i) {
                            Vue.prototype.$vsnackbar.show("上传成功");
                         }
                    }
                    this.returnData[i] = data[0];  
                }
                this.$emit("input", false);
                this.work();
            },
            doUploadProgress(event){
                this.progress = (event.loaded / this.imgList[this.global_param].size) * 100;
            }
        },
        watch: {
            dataImg() {
                this.display = true;
                var URL = window.URL || window.webkitURL;
                if (this.dataImg.files.length > 5) {
                    Vue.prototype.$valertbar.show("每次最多上传五张图片！");
                    return false
                }
                for (var i=0; i<this.dataImg.files.length; i++) {
                    var fileURL = URL.createObjectURL(this.dataImg.files[i]);
                    if (this.imgList.length == 5) {
                        Vue.prototype.$valertbar.show("每次最多上传五张图片！");
                        break
                    } else {
                        var obj = {
                            deleteFlag: true,
                            imgFlag: false,
                            progress: 0,
                            fileURL: fileURL,
                            file: this.dataImg.files[i]
                        }
                        this.imgList.push(obj)
                        this.imgCheckArray.push(this.dataImg.files[i])
                    }
                }
            },
            confirmEvent() {
                if (this.confirmEvent === true) {
                    for (var i=0;i<this.imgList.length;i++) {
                        this.imgList[i].imgFlag = true
                    }
                    // 上传图片check
                    var msg = this.comUtils.checkFilesUpload(this.imgCheckArray,'img',5)

                    if(msg !== undefined){
                         if (msg.snackbarText !== "") {
                                Vue.prototype.$valertbar.show(msg.snackbarText);
                                this.work();
                            } else {
                                this.doUpload();
                            }
                    }else{
                        this.work();
                    }
                   
                }
            }
        }
    }
</script>

<style scoped>
    .box {
        display: flex;
        flex-direction: column;
    }

    .button {
        align-self: flex-start;
    }

    .video-box {
        display: flex;
        width: 700px;
        height: 300px;
        margin: 50px 0;
    }

    .inner-box {
        display: flex;
        flex-direction: row;
        width: 100%;
        flex-wrap: wrap;
        position: relative;
    }
    .item {
        margin-left: 3px;
        margin-right: 3px;
    }

    .video {
        width: 448px;
        height: 273px;
        background: #000000;
    }

    .delete-img {
        position: relative;
        width: 23px;
        height: 23px;
        left: -12px;
        bottom: 100px;
    }

    .tip {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;
        margin-top: 20px;
        margin-left: 20px;
    }

</style>